import React from "react";
import { Plus, Trash2 } from "lucide-react";

export const DEFAULT_TIMELINE = [
  { label: "LOI signed", date: "", status: "done" },
  { label: "Due diligence complete", date: "", status: "upcoming" },
  { label: "Financing commitment", date: "", status: "upcoming" },
  { label: "Capital call", date: "", status: "upcoming" },
  { label: "Closing", date: "", status: "upcoming" },
  { label: "First distribution", date: "", status: "upcoming" },
];

export function TimelineEditor({ value, onChange }) {
  const rows = value?.length ? value : DEFAULT_TIMELINE;
  const upd = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="tl-editor" data-testid="timeline-editor">
      {rows.map((r, i) => (
        <div className="tl-edit-row" key={i}>
          <input className="inp" value={r.label} placeholder="Milestone" onChange={(e) => upd(i, "label", e.target.value)} data-testid={`tl-label-${i}`} />
          <input className="inp" type="date" value={r.date || ""} onChange={(e) => upd(i, "date", e.target.value)} data-testid={`tl-date-${i}`} />
          <select className="inp" value={r.status || "upcoming"} onChange={(e) => upd(i, "status", e.target.value)} data-testid={`tl-status-${i}`}>
            <option value="done">Done</option><option value="active">In progress</option><option value="upcoming">Upcoming</option>
          </select>
          <button className="icon-btn" onClick={() => onChange(rows.filter((_, j) => j !== i))} data-testid={`tl-del-${i}`}><Trash2 size={12} /></button>
        </div>
      ))}
      <button className="btn btn-sm" onClick={() => onChange([...rows, { label: "", date: "", status: "upcoming" }])} data-testid="tl-add"><Plus size={12} style={{ marginRight: 4 }} />Add milestone</button>
    </div>
  );
}

export function Timeline({ items, testid = "timeline" }) {
  const rows = (items?.length ? items : DEFAULT_TIMELINE).filter((r) => r.label);
  if (!rows.length) return <div className="bullet">Timeline not published yet.</div>;
  const fmt = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "TBD");
  return (
    <ol className="tl" data-testid={testid}>
      {rows.map((r, i) => (
        <li key={i} className={`tl-item ${r.status || "upcoming"}`} data-testid={`${testid}-item-${i}`}>
          <span className="tl-dot" />
          <div className="tl-body">
            <div className="tl-label">{r.label}</div>
            <div className="tl-date mono">{fmt(r.date)}{r.status === "active" ? " · in progress" : ""}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
